import React from 'react';
class ImageSet extends React.Component {

  constructor(props) {
    super(props);
    this.req = require.context('../../assets/', true);

    // Define image aliases here
    this.aliasMap = {
      // TODO: Move aliases to somewhere central location.
      '../../assets/category/adr_p.png': '../../assets/category/adr.png',
      '../../assets/category/adr_yp.png': '../../assets/category/adr.png',
      '../../assets/category/adr_e1.png': '../../assets/category/adr.png',
      '../../assets/category/adr_e7.png': '../../assets/category/adr.png',
      '../../assets/category/adr_es.png': '../../assets/category/adr.png',
      '../../assets/category/adr_tp.png': '../../assets/category/adr.png',
      '../../assets/category/adr_tp1.png': '../../assets/category/adr.png',
      '../../assets/category/adr_tp7.png': '../../assets/category/adr.png',
      '../../assets/category/adr_tps.png': '../../assets/category/adr.png',
      '../../assets/category/adr_tps1.png': '../../assets/category/adr.png',
      '../../assets/category/adr_tps7.png': '../../assets/category/adr.png',
      '../../assets/category/adr_tp17.png': '../../assets/category/adr.png',
      '../../assets/category/adr_tps17.png': '../../assets/category/adr.png',
      // Add more aliases as needed
    };
  }

  resolveMultipliedName(multiplier, source) {
    let nameArr = source.split('.');
    let name = nameArr[nameArr.length -2];
    name = name + '@' + multiplier + 'x';
    nameArr[nameArr.length-2] = name;
    return nameArr.join('.');
  };

  resolveAlias(source) {
    return this.aliasMap[source] || source;
  }

  filterPath(source) {
    const resolved = this.resolveAlias(source);
    return resolved.replace('../../assets/', '');
  }

  render() {

    let src = this.filterPath(this.props.src);
    let src2x = this.resolveMultipliedName(2, src);
    let imageProps = Object.assign({}, this.props);
    imageProps['src'] = this.req('./'+src);
    imageProps['srcSet'] = this.req('./'+src2x) + ' 2x';

    return (
      <img
        {...imageProps}
      />);
  }
}

export default (ImageSet)
